import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import PopUp from '../../GeneralComponents/PopUp';
import AuthContext from '../../AppAuthContext';
import apiService from '../../../services/apiService';
import DialogMembers from '../DialogMembers';
import { CustomTooltip } from '../../../styling/Styles';

/*
 * This component is used to display the available actions of a user for a project inside home projects table
 */
const ProjectActions = (props) => {
  const { project, setUpdateData, projectRole, showStatus } = props;

  const [openPopUp, setOpenPopUp] = useState(false);
  const [openLeaveProjectPopUp, setOpenLeaveProjectPopUp] = React.useState(false);
  const [isAddMember, setIsAddMember] = useState(false);
  const { state, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();

  // This function opens 'confirm delete project pop up'
  const openDeletePopUp = () => {
    setOpenPopUp(true);
  };

  // This function opens member dialog component
  const openAddMemberDialog = () => {
    setIsAddMember(true);
  };

  // This function deletes a project
  const deleteProject = () => {
    const { user } = state;

    const projectName = project.name;
    const projectOwner = project.owner;

    // Delete all pages of the project and then delete the project
    project.pages.forEach((page) => {
      apiService.deletePage(page, project._id).catch((error) => {
        throw error;
      });
    });

    apiService
      .deleteProject({ user, project })
      .then((response) => {
        localStorage.setItem('data', JSON.stringify(response.data));
        return response;
      })
      .catch((err) => {
        if (err.message === 'authentication failed') {
          dispatch({ type: 'LOGOUT' });
        }
      });

    apiService.deleteProjectRepo(projectName, projectOwner);
    apiService.deleteProjectsPendingInvitations({ user, project })

    setUpdateData(true);
    setOpenPopUp(false);
  };

  // This function navigates to edit project page.
  const editProject = () => {
    navigate('/edit_project', { state: { project } });
  };

  const closeLeaveProjectPopUp = () => {
    setOpenLeaveProjectPopUp(false);
  }

  const closeDeleteProjectPopUp = () => {
    setOpenPopUp(false)
  }

  const leaveProject = () => {
    const { user } = state;

    apiService
      .getUserWithParam({name: user.login})
      .then(response => {

        const userId = response.data._id;
        const members =  project.members.filter(mem => mem !== userId).map(member => member);

        apiService
        .updateProject2(project._id, { members })
        .then( () =>{
        
          apiService
          .deleteMember({projectId: project._id, userId})
          .catch((error) => {throw error;});
        })
        .catch((error) => {throw error;});
      })
      .then(() =>{
        setOpenLeaveProjectPopUp(false);
        setUpdateData(true);
      })
      .catch((error) => {throw error;});
  }
 
  return (
    <>
      <div className={clsx('flexRowDirection')} style={{ justifyContent: 'center' }}>
        {projectRole === 'owner' && showStatus === true ? (
          <EditDescriptionButton onClickAction={editProject} buttonText="Edit" />
        ) : ( projectRole === 'owner' && showStatus === false &&
          <DisabledEditDescriptionButton buttonText="Edit" />
        )}
        &nbsp;&nbsp;
        {projectRole === 'owner' && showStatus === true ? (
          <EditMembersButton onClickAction={openAddMemberDialog} buttonText="Members" />
        ) : ( projectRole === 'owner' && showStatus === false &&
          <DisabledEditMembersButton buttonText="Members" />
        )}
        &nbsp;&nbsp;
        {projectRole === 'owner' && showStatus === true ? (
          <DeleteIconButton project={project} onClickAction={openDeletePopUp} buttonText="Delete" />
        ) : (
            projectRole === 'owner' && showStatus === false &&
           <DisabledDeleteIconButton buttonText="Delete" />
        )
        }
        &nbsp;&nbsp;
        {projectRole === 'member' && showStatus === true ? (
          <LeaveProjectButton buttonText="Leave project" setOpenLeaveProjectPopUp={setOpenLeaveProjectPopUp}/> 
        ) : ( projectRole === 'member' && showStatus === false &&
          <DisabledLeaveProjectButton buttonText="Leave project" />
        )
        }
      </div>
      <DialogMembers
        open={isAddMember}
        setOpen={setIsAddMember}
        project={project}
        dispatch={dispatch}
        setUpdateData={setUpdateData}
      />
      <PopUp
        openAlert={openPopUp}
        setOpenAlert={setOpenPopUp}
        handleConfirm={deleteProject}
        handleCancel={closeDeleteProjectPopUp}
        title="Delete project"
        insideDescription="Are you sure you want to delete this project ?"
        confirmText='Delete'
        cancelText='Cancel'
        cause={`DeleteProject${project.name}`}
      />
      <PopUp
        openAlert={openLeaveProjectPopUp}
        setOpenAlert={setOpenLeaveProjectPopUp}
        handleConfirm={leaveProject}
        handleCancel={closeLeaveProjectPopUp}
        title='Leave project'
        insideDescription='Are you sure you want to leave this project ?'
        confirmText='Leave'
        cancelText='Cancel'
      />

    </>
  );
};

// This component renders edit description button
const EditDescriptionButton = ({ buttonText, onClickAction }) => (
  <div
    className={clsx('icon-button-style2', 'flexRowDirection', 'blueLabel3')}
    onClick={onClickAction}
    aria-hidden="true"
  >
    <div className={clsx('fas', 'fa-edit', 'functionsLogoStyle2')} />
    <div>&nbsp;</div>
    <span>{buttonText}</span>
  </div>
);

// This component renders disabled edit descripion button
const DisabledEditDescriptionButton = ({ buttonText }) => (
  <CustomTooltip title="Project is hidden">
    <div className={clsx('icon-button-style2', 'flexRowDirection', 'greyOutLabel')}>
      <div className={clsx('fas', 'fa-edit', 'functionsLogoStyle2')} />
      <div>&nbsp;</div>
      <span>{buttonText}</span>
    </div>
  </CustomTooltip>
);

// This component renders edit members button
const EditMembersButton = ({ onClickAction, buttonText }) => (
  <div
    className={clsx('user-actions-members-button', 'flexRowDirection')}
    onClick={onClickAction}
    aria-hidden="true"
  >
    <div className={clsx('fa', 'fa-users', 'functionsLogoStyle2')} />
    <div>&nbsp;</div>
    <span>{buttonText}</span>
  </div>
);

// This component renders disabled edit members button
const DisabledEditMembersButton = ({ buttonText }) => (
  <CustomTooltip title="Project is hidden">
    <div className={clsx('disabled-user-actions-members-button', 'flexRowDirection', 'greyOutLabel')}>
      <div className={clsx('fa', 'fa-users', 'functionsLogoStyle2')} />
      <div>&nbsp;</div>
      <span>{buttonText}</span>
    </div>
  </CustomTooltip>
);

// This component renders delete project button
const DeleteIconButton = ({ project, onClickAction, buttonText }) => (
  <div
    className={clsx('icon-button-style2', 'flexRowDirection', 'redLabel')}
    onClick={onClickAction}
    id={`deleteProject${project.name}`}
    aria-hidden="true"
  >
    <div className={clsx('fas', 'fa-trash', 'functionsLogoStyle2')} />
    <div> &nbsp;</div>
    <div>{buttonText}</div>
  </div>
);

// This component renders disabled delete project button
const DisabledDeleteIconButton = ({ buttonText }) => (
  <CustomTooltip title="Project is hidden">
    <div className={clsx('icon-button-style2', 'flexRowDirection', 'greyOutLabel')}>
      <div className={clsx('fas', 'fa-trash', 'functionsLogoStyle2')} />
      <div> &nbsp;</div>
      <div>{buttonText}</div>
    </div>
  </CustomTooltip>
);

// This component renders leave project button
const LeaveProjectButton = ({buttonText, setOpenLeaveProjectPopUp}) => (
    <div
      className={clsx('icon-button-style2', 'flexRowDirection', 'redLabel')}
      onClick={() => {setOpenLeaveProjectPopUp(true)}}
      aria-hidden="true"
    >
      <div className={clsx('fas', 'fa-sign-out-alt', 'functionsLogoStyle2')} />
      <div> &nbsp;</div>
      <div>{buttonText}</div>
    </div>
)

const DisabledLeaveProjectButton = ({buttonText}) => (

  <CustomTooltip title="Project is hidden">
    <div className={clsx('icon-button-style2', 'flexRowDirection', 'greyOutLabel')}>
      <div className={clsx('fas', 'fa-sign-out-alt', 'functionsLogoStyle2')} />
      <div> &nbsp;</div>
      <div>{buttonText}</div>
    </div>
  </CustomTooltip>
)

export default ProjectActions;
